export const optionsList = [{
  value: 'breakfast',
  label: 'Breakfast',
}, {
  value: 'teaAndCoffee',
  label: 'Tea & Coffee\u00A0break',
}, {
  value: 'lunch',
  label: 'Lunch',
}, {
  value: 'dinner',
  label: 'Dinner',
}, {
  value: 'drinksReception',
  label: 'Drinks reception',
}, {
  value: 'other',
  label: 'Other',
}];

export const extendedOptionsList = [
  {
    value: 'seatedMeal',
    label: 'Seated meal',
  },
  {
    value: 'drinksReception',
    label: 'Drinks reception',
  },
  {
    value: 'buffet',
    label: 'Buffet',
  },
  {
    value: 'openBar',
    label: 'Open bar',
  },
  {
    value: 'canapes',
    label: 'Canapés',
  },
];

export const emptyCateringOptions = {
  breakfast: false,
  teaAndCoffee: false,
  lunch: false,
  dinner: false,
  drinksReception: false,
  other: false,
};
